






































import { defineComponent, ref } from '@vue/composition-api'
import Draggable from 'vuedraggable'

type DraggableEvent = {
  moved?: {
    element: any
    newIndex: number
    oldIndex: number
  }
  added?: {
    element: any
    newIndex: number
  }
  removed?: {
    element: any
    oldIndex: number
  }
}

type Props = {
  label: string
  value: any[]
  disabled?: boolean
}

export default defineComponent({
  components: { Draggable },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context) {
    const editData = ref({
      isEditing: false,
      index: -1,
    })

    const form = ref({
      text: '',
    })

    const onAdd = () => {
      if (!form.value.text) {
        return
      }

      const text = form.value.text.trim()

      if (editData.value.isEditing) {
        context.emit('edit', {
          index: editData.value.index,
          name: text,
        })
      } else {
        context.emit('add', text)
      }
      editData.value.isEditing = false
      editData.value.index = -1
      form.value.text = ''
    }

    const onRemove = (index: number) => {
      context.emit('remove', index)
    }

    const edit = (index: number) => {
      editData.value.isEditing = true
      editData.value.index = index

      const target = props.value[index]
      form.value.text = target.name
    }

    const onChange = (evt: DraggableEvent) => {
      const moved = evt.moved
      if (!moved) {
        return
      }
      const newValue = Array.from(props.value)
      const target = newValue[moved.oldIndex]

      newValue.splice(moved.oldIndex, 1)
      newValue.splice(moved.newIndex, 0, target)

      context.emit('input', newValue)
    }

    return { form, onAdd, onRemove, onChange, edit }
  },
})
